import {
  LinearProgress,
  Table,
  TableBody,
  TableCell,
  TablePagination,
  TableRow,
  IconButton,
  Icon
} from "@material-ui/core";
import EnhancedTableHead from "components/EnhancedTableHead/EnhancedTableHead.jsx";
import { GetUserId, GetUserToken, Logout } from "helpers/UserHelper";
import { SearchDataSet } from "helpers/Search";
//Q&Ms
import { AssistantBrokers } from "queries/assistant/Broker_Assignment/BrokerAssignment.js";
import React, { Component } from "react";
import { Query } from "react-apollo";
import { Redirect } from "react-router";
import BaseTablePageContent from "./BaseTablePageContent";

const columnData = [
  {
    id: "edit",
    numeric: false,
    disablePadding: true,
    label: "",
    noSort: true,
    width: "30px"
  },
  { id: "su_name", numeric: false, disablePadding: true, label: "Name" },
  { id: "su_email", numeric: false, disablePadding: true, label: "Email" }
];

class ManageClients extends Component {
  state = {
    page: 0,
    rowsPerPage: 10,
    order: "desc",
    orderBy: "Name",
    searchTerm: "",
    loadingSearch: false,
    data: [],
    searchData: []
  };

  handleSearch = event => {
    this.setState({ searchTerm: event.target.value });

    let values = event.target.value.split(" ");
    var brokers = this.state.data;
    var inc = ["su_name", "su_surname", "su_email"];

    var filteredData = SearchDataSet(brokers, values, inc);
    this.setState({ searchData: filteredData });
  };

  handleChangePage = (event, page) => {
    this.setState({ page });
  };

  handleChangeRowsPerPage = event => {
    this.setState({ rowsPerPage: event.target.value });
  };

  handleRequestSort = (event, property) => {
    const orderBy = property;
    let order = "desc";

    if (this.state.orderBy === property && this.state.order === "desc") {
      order = "asc";
    }

    this.setState({ order, orderBy });
  };

  getSorting(order, orderBy) {
    return order === "desc"
      ? (a, b) => (b[orderBy] < a[orderBy] ? -1 : 1)
      : (a, b) => (a[orderBy] < b[orderBy] ? -1 : 1);
  }

  handleSelect = broker => {
    
    sessionStorage.setItem("ActiveBrokerId", broker.su_ID);
    sessionStorage.setItem(
      "ActiveBrokerName",
      broker.su_name + " " + broker.su_surname
    );
    this.setState();
  };

  render() {
    return (
      <Query
        query={AssistantBrokers}
        variables={{
          userId: GetUserId(),
          token: GetUserToken(),
          statuses: [2]
        }}
        fetchPolicy="network-only"
      >
        {({ loading, error, data, refetch }) => {
          if (loading)
            return (
              <React.Fragment>
                <BaseTablePageContent
                  handleSearch={e => {
                    return;
                  }}
                  title="Manage Clients - Select Broker"
                  hideFilter={true}
                >
                  <LinearProgress />
                </BaseTablePageContent>
              </React.Fragment>
            );

          if (
            error &&
            error.message &&
            error.message === "GraphQL error: invalid token"
          ) {
            Logout();
            return <Redirect to="/app/portal/login" />;
          }

          if (this.state.data.length !== data.AssistantBrokers.length) {
            this.setState({ data: data.AssistantBrokers });
          }

          let qData = [];
          if (
            this.state.searchData.length > 0 &&
            this.state.searchTerm !== ""
          ) {
            qData = this.state.searchData.slice();
            qData.sort(this.getSorting(this.state.order, this.state.orderBy));
          } else {
            qData = data.AssistantBrokers.slice();
            qData.sort(this.getSorting(this.state.order, this.state.orderBy));
          }

          return (
            <BaseTablePageContent
              handleSearch={this.handleSearch}
              changeClaimed={e => {
                this.setState({ onlyClaimed: e.target.checked });
                refetch();
              }}
              title="Select Broker"
              hideFilter={true}
            >
              <Table>
                <EnhancedTableHead
                  order={this.state.order}
                  orderBy={this.state.orderBy}
                  onRequestSort={this.handleRequestSort}
                  rowCount={
                    this.state.searchData.length < 1 &&
                    this.state.searchTerm !== ""
                      ? this.state.searchData.length
                      : qData.length
                  }
                  columnData={columnData}
                />
                <TableBody>
                  {this.state.searchData.length < 1 &&
                  this.state.searchTerm !== "" ? (
                    <TableRow>
                      <TableCell>
                        <h3>No results found</h3>
                      </TableCell>
                    </TableRow>
                  ) : (
                    qData
                      .slice(
                        this.state.page * this.state.rowsPerPage,
                        this.state.page * this.state.rowsPerPage +
                          this.state.rowsPerPage
                      )
                      .map(broker => {
                        return (
                          <TableRow
                            className="sqDataTable"
                            key={broker.su_ID}
                            onClick={e => this.props.handleSelect(broker)}
                            style={sessionStorage.getItem("ActiveBrokerId") == broker.su_ID ? { backgroundColor: '#f5f5f5' } : {}}
                          >
                            
                            {sessionStorage.getItem("ActiveBrokerId") == broker.su_ID ? 
                            (<TableCell
                              style={{
                                padding: "0px",
                                borderRight: "1px solid #e0e0e0",
                                backgroundColor: "white"
                              }}
                            >
                              
                              <IconButton
                               
                                onClick={e => this.props.handleSelect(broker)}
                              >
                                <Icon
                                style={{
                                  color: '#6c5cab'
                                }}
                                >check_circle</Icon>
                              </IconButton>
                            </TableCell>
                            )
                            :
                            (
                                <TableCell
                                style={{
                                  padding: "0px",
                                  borderRight: "1px solid #e0e0e0",
                                  backgroundColor: "white"
                                }}
                                >
                                  <IconButton
                                    onClick={e => this.props.handleSelect(broker)}
                                  >
                                    <Icon style={{
                                  color: '#6c5cab'
                                }}>radio_button_unchecked</Icon>
                                  </IconButton>
                                </TableCell>
                            )
                          }
                            
                            <TableCell>
                              {broker.su_name} {broker.su_surname}
                            </TableCell>
                            <TableCell>{broker.su_email}</TableCell>
                          </TableRow>
                        );
                      })
                  )}
                  <TableRow>
                    <TablePagination
                      count={
                        this.state.searchData.length < 1 &&
                        this.state.searchTerm !== ""
                          ? this.state.searchData.length
                          : qData.length
                      }
                      rowsPerPage={this.state.rowsPerPage}
                      page={this.state.page}
                      backIconButtonProps={{
                        "aria-label": "Previous Page"
                      }}
                      nextIconButtonProps={{
                        "aria-label": "Next Page"
                      }}
                      onChangePage={this.handleChangePage}
                      onChangeRowsPerPage={this.handleChangeRowsPerPage}
                    />
                  </TableRow>
                </TableBody>
              </Table>
            </BaseTablePageContent>
          );
        }}
      </Query>
    );
  }
}

export default ManageClients;



// WEBPACK FOOTER //
// ./src/views/Clients/components/ManageClients_elite.jsx